
import './_libs/jquery.validationEngine-ja';
import './_libs/jquery.validationEngine';

/**
 * contactページのバリデーション登録
 */
const validate = () => {
  const valid = {
    init: () => {
      valid.form = $('.wpcf7-form');

      valid.custom();
    },

    /**
     * 対象formの対象パーツをまわして
     * バリデーション項目をカスタマイズ
     */
    custom: () => {
      const formParts = ['input', 'textarea'];

      $.each(formParts, (i, tag) => {
        valid.form.find(tag).each((n, parts) => {
          const type = $(parts).attr('type');
          // hiddenは無視
          if (type !== 'hidden' && type !== 'submit' && type !== 'button') {
            // validationEngineの対象属性を追加
            const options = [];

            // 必須項目
            if ($(parts).attr('aria-required')) {
              options.push('required');
            }

            // メール
            if (type === 'email') {
              options.push('custom[email]');
            }

            // 電話番号
            if (type === 'tel') {
              options.push('custom[phone]');
            }

            // console.log(type, $(parts).attr('name'), options);
            $(parts).attr('data-validation-engine', `validate[${options}]`);
          }
        });
      });

      valid.run();
    },

    /**
     * バリデーションエンジンを起動
     */
    run: () => {
      valid.form.validationEngine({
        promptPosition: 'inline',
      });
    },
  };
  valid.init();
};


$(document).on('ready', () => {
  validate();
});



// WEBPACK FOOTER //
// ./assets/es6/validation.js